<template>
  <div id="smartTown">
    <div class="flex">
      <img
      src="@/assets/images/pic11.png"
      style="width: 100%; height: auto"
      alt=""
    />
    </div>
      <div class="text">
该产品实验室为中心，将实验室的各类业务流程、环境、人员、仪器设备、标准物质、化学试剂、标准方法、图书资料、文件记录、科研管理、项目管理等等因素统管起来的管理平台。本系统集人员管理、仪器设备管理、标准物质管理、库存管理、供应商管理、样品管理、文件管理、方法管理、环境管理以及质量管理等等诸多模块为一体，组成一套完整的实验室全面质量监控及管理体系，既能满足日常管理要求，又保证实验室数据控制质量。      </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
    line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/software9.vue